/*eslint-disable*/
import { createContext, useReducer } from 'react';
import type { FC, ReactNode } from 'react';
import PropTypes, { any } from 'prop-types';

const now = new Date();

interface State {
  landing: any | null;
}

interface GeneralContextValue extends State {
  setLanding: () => void;
}

interface GeneralProviderProps {
  children: ReactNode;
}

type SetLandingAction = {
  type: 'SETLANDING';
  payload: {
    landing: any;
  };
};

type Action = SetLandingAction;

const initialState: State = {
  landing: null,
};

const handlers: Record<string, (state: State, action: Action) => State> = {
  SETLANDING: (state: State, action: SetLandingAction): State => {
    const { landing } = action.payload;

    return {
      ...state,
      landing,
    };
  },
};

const reducer = (state: State, action: Action): State =>
  handlers[action.type] ? handlers[action.type](state, action) : state;

const GeneralContext = createContext<GeneralContextValue>({
  ...initialState,
  setLanding: () => null,
});

export const GeneralProvider: FC<GeneralProviderProps> = (props) => {
  const { children } = props;
  const [state, dispatch] = useReducer(reducer, initialState);

  const setLanding = () => {
    let landing = 0;
    const item = parseInt(localStorage.getItem('landing'));

    // here examines external data
    if (item) {
      landing = item;
    } else {
      // if it does not exist, a default value is assigned
      landing = 0;
    }

    dispatch({
      type: 'SETLANDING',
      payload: {
        landing: landing,
      },
    });
  };

  return (
    <GeneralContext.Provider
      value={{
        ...state,
        setLanding,
      }}
    >
      {children}
    </GeneralContext.Provider>
  );
};

GeneralProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GeneralContext;
